export default "__VITE_ASSET__DcHYfm1T__"